import { useMemo } from 'react';
import Utils from 'components/Utils';

export default function useId() {
  const id = useMemo(() => Utils.randomId(), []);
  return id;
}
